/* eslint-disable */

const Links = {
  Home: 'https://www.interseguro.pe',
  SAC: 'https://www.interseguro.pe',
  Chat: 'https://www.interseguro.pe', // 'https://www.interseguro.pe/?chat=1'
  WhatsApp: 'https://api.whatsapp.com/send?phone=5115000000',
  CentroDeAyuda: 'https://www.interseguro.pe/ayuda',
};

export default Links;



// WEBPACK FOOTER //
// ./src/interfaces/links.js